import { isEmpty } from 'lodash'
import { generateEmployeeId } from './generateEmployeeId'

export const getValidEmployeeId = (employeeId: string, orgName: string, name: string): string => {
  if (!orgName || !name) {
    throw new Error('orgName and name are required')
  }

  const generatedEmployeeId = generateEmployeeId(orgName, name)

  return isEmpty(employeeId) ? generatedEmployeeId : employeeId
}
